import { render } from "./CloserDeniedReason.vue?vue&type=template&id=9f5d58b2"
import script from "./CloserDeniedReason.vue?vue&type=script&lang=js"
export * from "./CloserDeniedReason.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__